import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useNewRirekishoFormatData,
  type NewRirekishoExampleSentence,
  type NewRirekishoExampleSentences
} from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoHistoriesApi } from '@/composables/format-edit/useNewRirekishoHistories'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoLicenseCard',
  props: {
    currentCardId: null,
    basicData: null,
    previewErrors: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  basicData: Record<string, unknown>
  previewErrors: Record<string, string>
  exampleSentences?: NewRirekishoExampleSentences
};

const descriptionMaxLength = 80



const formatData = useNewRirekishoFormatData()
const {
  activeHistoryItem,
  addLicenseHistory,
  deleteLicenseHistory,
  moveLicenseHistory,
  activateHistoryItem
} = useNewRirekishoHistoriesApi()

const exampleVisible = ref(false)

const licenseExamples = computed(() => props.exampleSentences?.license || [])

function onSelectExample(item: NewRirekishoExampleSentence) {
  addLicenseHistory(null, { description: item.description })
}

return { __sfc: true,descriptionMaxLength, props, formatData, activeHistoryItem, addLicenseHistory, deleteLicenseHistory, moveLicenseHistory, activateHistoryItem, exampleVisible, licenseExamples, onSelectExample, HistoryItem, NewRirekishoExampleSentenceDialog }
}

})